const phoneRegex               = /^[+]{0,1}[0-9]{3,17}$/; //Only + and digits allowed. Minimum 3 digits and maximum 17.
const vatRegex                 = /^[4][0-9]{9}$/;         //Vat number is 10 digits and starts with 4
const alphaNumericRegex        = /^[a-zA-Z0-9]*$/;
const companyRegistrationRegex = /^[a-zA-Z0-9\/]*$/;
const accountNumberRegex       = /^[0-9]{6,11}$/;
const branchNumberRegex        = /^[0-9]{6}$/;

                 
//Check Vat number provided is valid
export function isValidVat (value){
    if(!value){ return true; } 
    return vatRegex.test(value.trim().replace(new RegExp(' ', 'g'), ''));   //We allow space inside the VAT number
}

//Check the registration number provided is valid
export function isValidRegistration (value){
    if(!value){ return true; }
    return companyRegistrationRegex.test(value.trim().replace(new RegExp(' ', 'g'), ''));
}

//Check the phone provided is a valid phone
export function isValidPhone (value){
    if(!value){ return true; }
    return phoneRegex.test(value.trim().replace(new RegExp(' ', 'g'), '')); //We allow space inside the phone number
}

//Check the account number provided is valid
export function isValidAccountNumber (value){
    if(!value){ return true; }
    return accountNumberRegex.test(value.trim());
}

//Check the account number provided is valid
export function isValidBranchNumber (value){
    if(!value){ return true; }
    return branchNumberRegex.test(value.trim());
}